import React, { ElementType, MouseEventHandler, ReactNode } from 'react'
import { Backdrop as MUIBackdrop } from '@mui/material'

interface BackdropProps {
  open: boolean
  children?: ReactNode
  component?: ElementType<any>
  invisible?: boolean
  onClick?: (() => void) | MouseEventHandler<HTMLElement>
  sx?: object
}

/**
 * The backdrop component is used to provide
 * emphasis on a particular element or parts of it.
 */

const Backdrop = React.forwardRef((props: BackdropProps, ref: any) => {
  const { children, ...rest } = props

  return (
    <MUIBackdrop {...rest} ref={ref}>
      {children}
    </MUIBackdrop>
  )
})

Backdrop.displayName = 'Backdrop'
export default Backdrop
